import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";

import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import objectPath from "object-path";
import {useHtmlClassService} from "../../../_core/MetronicLayout";
import {toAbsoluteUrl} from "../../../../_helpers";

//components:
import {Dropdown} from "react-bootstrap";
import {DropdownTopbarItemToggler} from "../../../../_partials/dropdowns";
import AccountBoxRoundedIcon from "@material-ui/icons/AccountBoxRounded";
import {sendDataLayer} from "../../../../../app/util/tagmanager";

const UserProfileDropdown = () => {
    const uiService = useHtmlClassService();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const contextSelector = useSelector(state => state.context);

    const layoutProps = useMemo(() => {
        return {
            light: objectPath.get(uiService.config, "extras.user.dropdown.style") === "light",
        };
    }, [uiService]);

    //redux:
    //store:
    const contextCredential = useSelector(state => state.context.credential);
    const profile = useSelector(state => state.userParameters.credential);

    return (
        <div className="d-flex z-index-3">
            <Dropdown drop="down" alignRight>
                <Dropdown.Toggle as={DropdownTopbarItemToggler} id="dropdown-toggle-user-profile">
                    <div className="user_profile_navlink btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-auto">
                        <span className="user_hi">{t("HEADER.PROFILE.HI")}</span>
                        <span className="user_name">
                            {profile?.name ||
                                profile?.username ||
                                contextCredential?.name ||
                                contextCredential?.username}
                        </span>
                        <img
                            className="header_profile_img bg_image_cover rounded"
                            src={profile?.avatar_url || contextCredential?.avatar_url || "/media/users/default.jpg"}
                        />
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg p-0">
                    <>
                        {layoutProps.light && (
                            <>
                                <div className="d-flex align-items-center p-8 rounded-top">
                                    <span
                                        className="dropdown_profile_img bg_image_cover rounded mr-3"
                                        style={{
                                            backgroundImage: `url(${profile?.avatar_url ||
                                                contextCredential?.avatar_url ||
                                                "/media/users/default.jpg"})`,
                                        }}
                                    />
                                    <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                                        {`${profile?.name || contextCredential?.name} ${profile?.surname ||
                                            contextCredential?.surname}` || ""}
                                    </div>
                                </div>
                                <div className="separator separator-solid"></div>
                            </>
                        )}

                        {!layoutProps.light && (
                            <div
                                className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
                                style={{
                                    backgroundImage: `url(${toAbsoluteUrl("/media/misc/bg-1.jpg")})`,
                                }}
                            >
                                <div className="symbol bg-white-o-15 mr-3">
                                    <span className="symbol-label text-success font-weight-bold font-size-h5">
                                        {profile?.name[0] ||
                                            profile?.username[0] ||
                                            contextCredential?.name[0] ||
                                            contextCredential?.username[0]}
                                    </span>
                                </div>
                                <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
                                    {profile?.name ||
                                        profile?.username ||
                                        contextCredential?.name ||
                                        contextCredential?.username}
                                </div>
                            </div>
                        )}
                    </>

                    <div className="navi navi-spacer-x-0 pt-5 w-100">
                        <Link className="navi-item px-8" to={`/profile`}>
                            <div className="navi-link profile_menu_link">
                                <div className="navi-icon mr-2">
                                    <AccountBoxRoundedIcon className="icon_svg_custom icon_svg_success" />
                                </div>
                                <div className="navi-text">
                                    <div className="font-weight-bold">{t("HEADER.BUTTONTEXT.PROFILE")}</div>
                                    <div className="text-muted">{t("HEADER.BUTTON.PROFILE.SUBTITLE")}</div>
                                </div>
                            </div>
                        </Link>
                    </div>

                    <div className="navi-separator mt-3" />

                    <div className="navi-footer px-8 py-5">
                        <button
                            onClick={() => {
                                sendDataLayer(
                                    {
                                        event: "session_logout",
                                    },
                                    {context: contextSelector}
                                );
                                dispatch({type: "CLEAR_STORE"});
                            }}
                            className="btn btn-light-primary font-weight-bold ml-auto"
                        >
                            {t("HEADER.BUTTON.LOGOUT")}
                        </button>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default UserProfileDropdown;
